import React, { SVGAttributes } from 'react';

const EighteenPlus: React.FC<{ className?: SVGAttributes<SVGSVGElement>['className'] }> = ({ className }) => (
	<svg className={className} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 61 61">
		<g fillRule="evenodd">
			<path
				d="M19.222 40.546v-16.32H15.45v-4.18h8.977v20.5M33.727 25.63c0 1.463
      1.053 2.28 2.954 2.28 1.902 0 2.954-.817 2.954-2.28
      0-1.52-1.052-2.37-2.953-2.37-1.9 0-2.953.85-2.953 2.37m-.527 8.687c0
      1.725 1.23 2.69 3.48 2.69 2.253 0 3.51-.936 3.51-2.69
      0-1.696-1.257-2.662-3.51-2.662-2.252 0-3.48.965-3.48
      2.662m10.792-8.98c0 1.785-.964 3.364-2.574 4.24 2.252.938 3.656
      2.897 3.656 5.178 0 3.685-3.275 6.025-8.393 6.025-5.117
      0-8.393-2.31-8.393-5.937 0-2.34 1.52-4.328
      3.89-5.265-1.725-.964-2.837-2.602-2.837-4.386 0-3.276 2.866-5.352
      7.312-5.352 4.503 0 7.34 2.134 7.34 5.498"
			/>
			<path
				d="M53.736 22.36c.866 2.553 1.305 5.225 1.305 7.95 0 13.663-11.115
      24.78-24.78 24.78-13.662 0-24.777-11.117-24.777-24.78 0-13.664
      11.115-24.78 24.778-24.78 2.727 0 5.398.44 7.953
      1.305V1.32C35.633.615 32.968.256 30.26.256 13.69.255.208 13.738.208
      30.31S13.69 60.365 30.26 60.365c16.574 0 30.057-13.483 30.057-30.055
      0-2.707-.36-5.37-1.066-7.95h-5.514z"
			/>
			<path
				d="M52.237
      8.318V2.555h-4.144v5.763h-5.728v4.144h5.728v5.762h4.144v-5.762H58V8.318"
			/>
		</g>
	</svg>
);

export default EighteenPlus;
